import React, { Component } from 'react'
import Dashboard from "../../layouts/DashboardLayOut";

export class ComingSoonPage extends Component {
  render() {
    return (
      <Dashboard>
      <h1>Coming Soon?</h1>
    </Dashboard>
    )
  }
}

export default ComingSoonPage
